import styled from 'styled-components';

export const PublicShell = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Byline = styled.span`
  min-width: 0;
  overflow: hidden;
  font-size: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;
